// extracted by mini-css-extract-plugin
module.exports = {"headCell":"orStyles_headCell__1TUWm","headCellWide":"orStyles_headCellWide__3ww_-"};